import React, { ReactNode } from 'react';
import { Box, Typography } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { READY_HEADLINE, READY_STEP } from '../constants';
import { KEY_GUARD_ACTIVATE } from './keyGuard';
import { getOverlayStyles } from './overlayStyles';
import {
  MINI_GAME_BACK,
  MINI_GAME_ENTER,
  MINI_GAME_KEEP_PLAYING,
} from './constants';

interface IReadyBannerProps {
  classes: ReturnType<typeof getOverlayStyles>;
  clockLine: ReactNode;
  fuseShare: number | null;
  failed: boolean;
  onEnter: () => void;
  onKeepPlaying: () => void;
  onBack: () => void;
}

const ReadyBanner = ({
  classes,
  clockLine,
  fuseShare,
  failed,
  onEnter,
  onKeepPlaying,
  onBack,
}: IReadyBannerProps) => (
  <Box
    sx={[classes.scrim, classes.readyScrim]}
    data-testid="myta-minigame-ready"
  >
    <Box sx={[classes.card, classes.readyCard]}>
      <Typography component="span" sx={classes.readyKicker}>
        {READY_STEP}
      </Typography>
      <Typography component="h2" sx={classes.readyHeadline}>
        {READY_HEADLINE}
      </Typography>
      {clockLine ? (
        <Typography
          component="p"
          sx={classes.readyClock}
          data-testid="myta-minigame-countdown"
        >
          {clockLine}
        </Typography>
      ) : null}
      <Box sx={classes.cardActions}>
        <Box
          component="button"
          type="button"
          sx={classes.cta}
          onClick={onEnter}
          autoFocus
          {...KEY_GUARD_ACTIVATE}
          data-testid="myta-minigame-enter"
        >
          {MINI_GAME_ENTER}
          <ArrowForwardIcon />
        </Box>
        <Box
          component="button"
          type="button"
          sx={classes.ghostBtn}
          onClick={failed ? onBack : onKeepPlaying}
          {...KEY_GUARD_ACTIVATE}
          data-testid="myta-minigame-keep-playing"
        >
          {failed ? MINI_GAME_BACK : MINI_GAME_KEEP_PLAYING}
        </Box>
      </Box>
      {fuseShare !== null ? (
        <Box sx={classes.fuse} data-testid="myta-minigame-fuse">
          <Box
            sx={classes.fuseFill}
            style={{ transform: `scaleX(${fuseShare})` }}
          />
        </Box>
      ) : null}
    </Box>
  </Box>
);

export default ReadyBanner;
